import React, { useState, useEffect, useRef } from "react";
import { Form, FormGroup, Label, Input, DropdownItem } from "reactstrap";
import { Container, Row, Col, Spinner } from "react-bootstrap";

import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";
// Validation helpers

import { validate } from "helpers/validations";
// Components

// Store

import { loginUser, polygonSignIn } from "store/actions";
import axios from "axios"
import { updateToken } from "../../helpers/api_helper";
import QRCodeStyling from "qr-code-styling";
export default function Login() {
  const { settings } = useSelector((state) => state?.Login);
  const globalStateAuthToken = useSelector((state) => state?.Login?.authToken);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [userId, setUserId] = useState('');
  const { Login } = useSelector((state) => state);
  const [intervalId, setIntervalId] = useState(null);
  const [OpenPrivado, setOpenPrivado] = useState(false)
  const [timeoutId, setTimeoutId] = useState(null); // S
  const [fields, setFields] = useState({
    email: "",
    password: ""
  });
  const [loginLoading, setLoginLoading] = useState(false)
  const { email, emailError, password, passwordError } = fields;
  const [passwordtype, setPasswordType] = useState("password");
  let didInit = false;
  

  useEffect(() => {
    if (!didInit) {
      didInit = true;
      localStorage.removeItem("authUser");
    }
  }, []);
  const checkPolygonAuthStatus = async () => {
    try {
      const authData = await axios.get(`${process.env.REACT_APP_JS_VERIFIER_URL}v1/user/checkPolygonAuth`, {
        params: {
          user_id: userId,
        },
      });


      // Check if polygon_auth is true
      if (authData.data.polygon_auth) {
        clearInterval(intervalId); // Clear the interval
        clearTimeout(timeoutId); // Clear the timeout
        localStorage.setItem("authToken", JSON.stringify(globalStateAuthToken));
        toastr.success("Logged in successfully");
        // setIntervalId(null); // Reset intervalId state
        // setTimeoutId(null); // Reset timeoutId state
        navigate("/"); // Redirect to the desired page
      }
    } catch (error) {
      console.error("Error checking Polygon Auth status:", error);
    }
  };

  const startPolling = () => {
    const intervalDuration = 10000; // 10 seconds
    const maxPolls = 10; // Run polling 10 times
    let pollCount = 0; // Counter to track the number of polls

    // Start the interval and save its ID
    const interval = setInterval(async () => {
      pollCount+=1;
      const polygonauthData = await checkPolygonAuthStatus(); 
      if (pollCount >= maxPolls) {
        clearInterval(interval); 
        setIntervalId(null); 
        toastr.error("Authentication Failed");
        localStorage.clear()
        setOpenPrivado(!OpenPrivado)
        navigate("/login"); // Redirect to login if max polls are reached
      }
    }, intervalDuration);

    setIntervalId(interval); // Save interval ID in state
  };

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [intervalId]);
  useEffect(() => {
    if (OpenPrivado === true && userId !== "" && userId !== undefined && userId!==null) {
      const getAuthData = async () => {
        try {
          // http://localhost:5000/api/sign-in
          const authData = await axios.get(`${process.env.REACT_APP_JS_VERIFIER_URL}sign-in`, {
            params: {
              user_id: userId,
            },
          });


          setQrData(authData.data); // Save initial QR data
          startPolling(); // Start polling
        } catch (error) {
          console.error("Error fetching auth data:", error.message);
        }
      };

      getAuthData();
    }

    // Cleanup: stop polling if component unmounts or OpenPrivado/userId changes
    return () => {
      if (intervalId) {
        clearInterval(intervalId); // Clear the interval on cleanup
      }
      if (timeoutId) {
        clearTimeout(timeoutId); // Clear the timeout on cleanup
      }
    };
  }, [OpenPrivado, userId]); // Reactivity based on OpenPrivado and userId


  const handleKeyDown = (event) => {
    if (event.getModifierState('CapsLock')) {
      setIsCapsLockOn(true);
      setShowTooltip(true);
    } else {
      setIsCapsLockOn(false);
      setShowTooltip(false);
    }
  };
  const handleKeyUp = (event) => {
    if (!event.getModifierState('CapsLock')) {
      setIsCapsLockOn(false);
      setShowTooltip(false);
    }
  };
  const onChangeHandler = (e) => {
    e.persist();
    const { value, name } = e.target;
    setFields((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value }
    );
  };


  const showpassword = () => {
    if (passwordtype === "password") {
      setPasswordType("text")
      return;
    }
    setPasswordType("password")
  }
  const onSubmit = async (e) => {
    e.preventDefault();
    let response = validate(fields);
    setFields((prev) => ({ ...prev, ...response }));
    let data = { email, password };
    setLoginLoading(true)
    const callback = (res) => {
      setLoginLoading(false)
      const { message, status } = res;
      if ((status == "failure") && (message === "Email is not verified")) {
        return toastr.error(message);
      }
      if (status == "failure") {
        toastr.error("Either your email or password is incorrect, Authentication Failed!");
      } else {
        navigate("/");
        localStorage.setItem("authToken", JSON.stringify(globalStateAuthToken));
        localStorage.removeItem("walletAddress");
        toastr.success("Logged in successfully");

      }
    };
    dispatch(loginUser(data, callback));
  };

  const Privado = async (e) => {
    e.preventDefault();
    //  await onSubmit
    // setOpenPrivado(!OpenPrivado)
    let response = validate(fields);
    setFields((prev) => ({ ...prev, ...response }));
    let data = { email, password };
    const callback = (res) => {
      const { message, status } = res;
      if ((status == "failure") && (message === "Email is not verified")) {
        return toastr.error(message);
      }
      if (status == "failure") {
        toastr.error("Either your email or password is incorrect, Authentication Failed!");
      } else {
        setUserId(res.data.user_id)
        setOpenPrivado(!OpenPrivado)
      }
    };
    dispatch(loginUser(data, callback));
  }

  const signupprivado = (e) =>{
   
    
    navigate("/users/register", { state: { signUpwithPrivado: 'privado' } });
  }
  // const signupprivado2 = (e) => {
  //   navigate("/users/register");
  // }

  // const ref= useRef();
  // const [qrCodeRef, setQrCodeRef] = useState()



  const qrCodeRef = useRef();
  const [qrData, setQrData] = useState()
  useEffect(() => {
    const qrCode = new QRCodeStyling({
      width: 300,
      height: 300,
      data: JSON.stringify(qrData),
      dotsOptions: {
        color: "#000000",
        type: "rounded",
      },
      backgroundOptions: {
        color: "#ffffff",
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 20,
      },
    });

    qrCode.append(qrCodeRef.current);
  }, [qrData]);



  return (
    <>
      <section className="container-fluid authMaine">
        <div className="row h-100">
          <Col lg="7" className="authLeft">
            <img src="../../images/svg/loginimg2.svg" className="Loginim" alt="Login" />
          </Col>
          <Col lg="5" className="authRight">
            <div className="loginInner">

              <div className="logobx">
                {/* <button className="btn border-0"><i className="fa-sharp fa-light fa-arrow-left-long"></i> Back</button> */}
                <a href="https://terpnash.com/" rel="noreferrer" className="navbar-brand mx-auto py-0">
                  {settings?.logo?.link && (
                    <div className="d-flex align-items-center justify-content-start position-relative gap-3">
                      <>
                        {settings?.logo?.link.search(".mp4") !== -1 ? (

                          <img
                            src={settings?.logo?.link || "/images/t3.gif"}
                            // src={"/images/t3.gif"}
                            alt="logo"
                          />
                        ) : (
                          <img
                            alt="logo"
                            className="img-fluid logodesktop"
                            src={settings?.logo?.link || "/images/t3.gif"}
                          // src={"/imagbes/t3.gif"}
                          />
                        )}
                      </>

                      {/* <a href="https://terpnash.com/" rel="noreferrer" className="nav-link loginLogo logohead ">
                      Terpnash
                    </a> */}
                    </div>
                  )}
                </a>
              </div>
              <Form>
                <div className="artist-submission create-nftform text-start mt-4">
                  {/* {state?.tab == "tab1" ? ( */}
                  <h1>Welcome Back !</h1>
                  <p>Enter your login information now.</p>
                  <Row className="mt-4">
                    <Col lg={12} md={12} sm={12}>
                      <FormGroup className="position-relative ">
                        {/* <Label htmlFor="exampleEmail">Email address</Label> */}
                        <Input
                          pattern={
                            fields?.email == ".+@gmail.com" ||
                            fields?.email == ".com"
                          }
                          type="email"
                          name="email" className="inputwithicon"
                          value={email}
                          invalid={emailError}
                          required={emailError}
                          onChange={onChangeHandler}
                          placeholder="Enter your registered email"
                        />
                        <div className="btn position-absolute top-0 start-0  border-0 bottom-0 my-auto ">
                          <i className="fa-sharp fa-regular fa-envelope-open"></i>
                        </div>
                      </FormGroup>
                    </Col>

                    <Col lg={12} md={12} sm={12}>
                      <FormGroup className="password-divmain position-relative">
                        {/* <div className="password-div">
                        <Label htmlFor="examplePassword">Password</Label>
                      </div> */}
                        <Input
                          type={passwordtype}
                          name="password" className="inputwithicon pe-5"
                          value={password}
                          invalid={passwordError}
                          required={passwordError}
                          onKeyDown={handleKeyDown}
                          onKeyUp={handleKeyUp}
                          onChange={onChangeHandler}
                          placeholder="Enter your password"
                        />
                        {isCapsLockOn && showTooltip && (
                          <div
                            style={{
                              position: 'absolute',
                              top: '50px',
                              left: '10px',
                              padding: '8px',
                              backgroundColor: 'black',
                              color: 'white',
                              borderRadius: '4px',
                              fontSize: '14px',
                              zIndex: 1000,
                            }}
                          >
                            Caps Lock is ON
                          </div>
                        )}
                        <div className="btn position-absolute top-0 start-0 bottom-0 border-0 my-auto ">
                          <i className="fa-regular fa-lock-keyhole"></i>
                        </div>
                        <button type="button" onClick={showpassword} className="btn position-absolute top-0 end-0 bottom-0 my-auto border-0 inpicon">
                          {passwordtype === 'password' ? <i className="fa-light fa-eye-slash"></i> : <i className="fa-light fa-eye"></i>}
                        </button>
                      </FormGroup>
                    </Col>
                  </Row>
                  <p className="login_forgot w-auto">
                    <Link className="link_text" to="/forgot-password">
                      Forgot Password?
                    </Link>
                  </p>
                  <div className="logginbtns">
                    {/* {Login?.loading ? (
                    <button className="btn btn-primary">
                      <Spinner animation="border" role="status"></Spinner>
                    </button>
                  ) : (
                   
                  )} */}
                    <button
                      onClick={onSubmit}
                      type="submit"
                      className=" btn btn-primary"
                      disabled={emailError || passwordError}
                    >
                      Login {loginLoading ? (<Spinner animation="border" size="sm" role="status"></Spinner>) : ('')}
                    </button>
                    <b style={{ fontWeight: '700' }}>Or</b>
                    <button className="btn prevadobtn" onClick={(e) => Privado(e)} type="button">Login with Privado iD <img src="../../images/svg/prevadoIcon.svg" /></button>
                  </div>

                  <div className="creetea-account signupbottomText text-center">
                    <p className="text-light2 fw-medium mb-0new">
                      <span className="text-new_user "> Don’t have an account?  <Link to="/users/register"><span className="text-black fw-bold">Signup</span></Link></span>
                    </p>
                  </div>
                  <hr className="mt-0 mx-auto" style={{ width: '95%' }} />
                  <div className="logginbtns fullbtn">
                    <button type="button" onClick={signupprivado} className="btn prevadobtn">Signup with Privado iD <img src="../../images/svg/prevadoIcon.svg" /> </button>
                  </div>
                </div>
              </Form>
            </div>
          </Col>

        </div>
      </section>
      {OpenPrivado == true && <div className="barcodeBoxMaine">
        <div className="barcodeInner">
          <bottom onClick={Privado} className="qrclosebtn" type="button"><i class="fa-regular fa-xmark"></i></bottom>
          <div className="qrbox">
            <div>
              <div ref={qrCodeRef}></div>
            </div>
            {/* src="../../images/svg/qrcode.svg" */}
          </div>
          <p>Scan this QR with your Privado ID <br /> application to verify.</p>
          <div className="disclaimerBox">
            <b>Disclaimer:</b> Once you verify this with your Privado app, you will be redirected to the Terpnash marketplace. It will take a few seconds to verify, so please be patient and hold tight.
          </div>
        </div>
      </div>}


      {/* <section className="Artistsubmission-main create-nft" hidden>
        <Container>
          <div className="artist-submission login-sub">
            {/ Tabbing  }

             <Form>
              <div className="DigitalArtcollection-head text-center loginh2">
                <div className="send-tabling">
                  <div className="tab-frame send-tabframe login_frame mt-5">
                    <div className="clearfix">
                      <input
                        onChange={() =>
                          setFields((prev) => ({
                            ...prev,
                            role: "ARTIST",
                          }))
                        }
                        type="radio"
                        name="tab"
                        id="tab1"
                        checked={state.tab == "tab1"}
                        onClick={() => setState({ tab: "tab1" })}
                      />
                      <label className="tab_label" htmlFor="tab1">
                        Artist
                      </label>

                      <input
                        onChange={() =>
                          setFields((prev) => ({
                            ...prev,
                            role: "MUSEUM",
                          }))
                        }
                        type="radio"
                        name="tab"
                        id="tab3"
                        checked={state.tab == "tab3"}
                        onClick={() => setState({ tab: "tab3" })}
                      />
                      <label className="tab_label" htmlFor="tab3">
                        Museum
                      </label>

                      <input
                        onChange={() =>
                          setFields((prev) => ({
                            ...prev,
                            role: "USER",
                          }))
                        }
                        type="radio"
                        name="tab"
                        id="tab2"
                        checked={state.tab == "tab2"}
                        onClick={() => setState({ tab: "tab2" })}
                      />
                      <label className="tab_label" htmlFor="tab2">
                        Users
                      </label>
                    </div>

                    {state.tab == "tab1" && (
                      <div className="sendcurreny-main common-form mt-5"></div>
                    )}

                    {state.tab == "tab2" && (
                      <div className="sendcurrenyfait-main common-form mt-5"></div>
                    )}

                    {state.tab == "tab3" && (
                      <div className="sendcurrenyfait-main common-form mt-5"></div>
                    )}
                  </div>
                </div>
              </div>
              <div className="artist-submission create-nftform">
                {/* {state?.tab == "tab1" ? ( */}
      {/* <Row>
                  <Col lg={12} md={12} sm={12}>
                    <FormGroup>
                      <Label htmlFor="exampleEmail">Email address</Label>
                      <Input
                        pattern={
                          fields?.email == ".+@gmail.com" ||
                          fields?.email == ".com"
                        }
                        type="email"
                        name="email"
                        value={email}
                        invalid={emailError}
                        required={emailError}
                        onChange={onChangeHandler}
                        placeholder="abc@gmail.com"
                      />
                    </FormGroup>
                  </Col>

                  <Col lg={12} md={12} sm={12}>
                    <FormGroup className="password-divmain">
                      <div className="password-div">
                        <Label htmlFor="examplePassword">Password</Label>
                      </div>
                      <Input
                        type="password"
                        name="password"
                        value={password}
                        invalid={passwordError}
                        required={passwordError}
                        onChange={onChangeHandler}
                        placeholder="Password"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Link className="link_text" to="/forgot-password">
                  <p className="login_forgot">Forgot Password</p>
                </Link>

                <div className="text-center Done-wrap">
                  {Login?.loading ? (
                    <button className="showmore btn btn-primary Submit-btn">
                      <Spinner animation="border" role="status"></Spinner>
                    </button>
                  ) : (
                    <button
                      onClick={onSubmit}
                      type="submit"
                      className="showmore btn btn-primary Submit-btn"
                      disabled={emailError || passwordError}
                    >
                      Login
                    </button>
                  )}
                </div>

                <div className="creetea-account text-center">
                  <p>
                    <span className="text-new_user"> New user?</span>
                    <div className="slection_col">
                      <UncontrolledDropdown>
                        <DropdownToggle caret className="create-green">
                          Create an account
                        </DropdownToggle>
                        <DropdownMenu>
                          <Link to="/artist-submission">
                            <DropdownItem>Artist</DropdownItem>
                          </Link>
                          <Link to="/museums/register">
                            <DropdownItem>Museum</DropdownItem>
                          </Link>
                          <Link to="/users">
                            <DropdownItem>User</DropdownItem>
                          </Link>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </p>
                </div>
              </div> */}
      {/* </Form>
          </div>
        </Container>
         <LoginBanner />
      </section> */}
    </>
  );
}
